import { Col, Row, Skeleton, Table } from "@pankod/refine-antd";
import { IResourceComponentsProps, useCustom } from "@pankod/refine-core";
import DownloadMenu from "components/DownloadDropdown";
import dayjs from "dayjs";
import ENV from "utils/env";
import {
  exportToCsv,
  exportToExcel,
  exportToJson,
} from "utils/utiltyFunctions";
import { useDashboard } from "dashboardProvider";
export const TableMostAttendedBranchDetails: React.FC<
  IResourceComponentsProps
> = () => {
  const { selectedDashboard } = useDashboard();

  const {
    data: response,
    isFetching,
    isError,
  } = useCustom({
    url: `${ENV.API_URL}/api/campaign/lottery/mostAttendedBranchDetails`,
    method: "get",
    config: {
      query: {
        dbkey: selectedDashboard,
      },
    },
  });
  if (isFetching) {
    return <Skeleton />;
  }
  if (isError) {
    return (
      <span style={{ fontWeight: 800, fontSize: 20 }}>Veri bulunamadı.</span>
    );
  }

  const dataSource = response.data.filteredBranches.map((item: any) => {
    return {
      key: item["shopCode"],
      name: item["name"],
      count: item["count"],
      salesManager: item["salesManager"] ? item["salesManager"] : "-",
      areaManager: item["areaManager"] ? item["areaManager"] : "-",
      city: item["city"] ? item["city"] : "-",
      area: item["area"] ? item["area"] : "-",
    };
  });

  const uniqueAreas = Array.from(new Set(dataSource.map((item) => item.area)))
    .map((area) => ({ text: area as string, value: area as string }))
    .sort((a, b) => a.text.localeCompare(b.text));

  const uniqueCities = Array.from(new Set(dataSource.map((item) => item.city)))
    .map((city) => ({ text: city as string, value: city as string }))
    .sort((a, b) => a.text.localeCompare(b.text));

  const thirdTabColumns = [
    {
      title: "Mevcut Tim Kodu",
      dataIndex: "key",
      key: "key",
      width: "25%",
    },
    {
      title: "Turkcell Adı",
      dataIndex: "name",
      key: "name",
      width: "25%",
    },
    {
      title: "Sayı",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Satış Müdürü",
      dataIndex: "salesManager",
      key: "salesManager",
      width: "25%",
    },
    {
      title: "Bölge Müdürü",
      dataIndex: "areaManager",
      key: "areaManager",
      width: "25%",
    },
    {
      title: "Şehir",
      dataIndex: "city",
      key: "city",
      width: "25%",
      filters: uniqueCities, // Benzersiz şehirleri filtre olarak ekle
      onFilter: (value: string, record: any) => record.city === value, // Filtreleme işlevi
    },
    {
      title: "Bölge",
      dataIndex: "area",
      key: "area",
      width: "25%",
      filters: uniqueAreas, // Benzersiz bölgeleri filtre olarak ekle
      onFilter: (value: string, record: any) => record.area === value, // Filtreleme işlevi
    },
  ];

  const updatedAt = response.data.updatedAt;
  const parsedUpdatedAt = dayjs(updatedAt).format("DD/MM/YYYY HH:mm");
  const formattedDate = updatedAt
    ? dayjs(updatedAt).format("DD-MM-YYYY-HH-mm")
    : "";

  return (
    <div>
      <Row justify="end" gutter={16}>
        <Col>
          <DownloadMenu
            dataSource={dataSource}
            columns={thirdTabColumns}
            formattedDate={formattedDate}
            exportToExcel={exportToExcel}
            exportToCsv={exportToCsv}
            exportToJson={exportToJson}
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>Son Güncelleme Tarihi:</Col>
        <Col span={6}>
          {dayjs(response.data.updatedAt).format("DD/MM/YYYY HH:mm")}
        </Col>
        <Col span={6} style={{ fontWeight: 600 }}>
          Veriler her 5 dakikada bir güncellenmektedir.
        </Col>
        <Col span={12} />
      </Row>
      <Table
        dataSource={dataSource}
        columns={thirdTabColumns}
        pagination={{ pageSize: 25, disabled: false }}
        scroll={{ x: 1500 }}
      />
    </div>
  );
};
